<template>
    <section class="login-section" :class="clase">
        <div class="thumb-container absolute" :style='"background-image: url(" + footer.bg3_url + ")"'></div>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-10">
                    <div class="min-height-100vh d-flex align-items-center">
                        <div class="w-100 text-center d-lg-flex flex-column align-items-center">
                            <div class="club-title-content white" :style='"background-image: url(" + logo + ")"'>
                                <div class="title club-title h1" v-if="title">{{ title }}</div>
                                <div class="subtitle h3 regular alttextcolor">{{ $t('home.subtitle') }}</div>
                            </div>
                            <div class="row justify-content-center home-links">
                                <slot></slot>
                            </div>
                            <div class="contentCentered">
                                <span class="white">{{ $t('home.producto') }}:</span>
                                <img 
                                    src="https://apiteatros.compralaentrada.com/images/logo_compralaentrada_white.png" 
                                    width="80"
                                    alt="Compralaentrada"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            clase: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                required: false
            }
        },
        computed: {
            footer() {
                return this.$store.getters.getFooter;
            },
            logo() {
                if(this.footer.tipo == 2) {
                    return this.footer.logo_teatros;
                } else {
                    return this.footer.logo;
                }
            }
        }
    }
</script>
<style scoped>
    .contentCentered{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
    }
    .contentCentered img {
        width: 280px;
    }
    .contentCentered span {
        display: block;
        margin: 0 0 12px;
        font-family: "Oswald", sans-serif;
        font-size: 16px;
    }
</style>